export default __webpack_public_path__ + "static/technology-stack-feature-image-bc667c8f800a18354ab4a7e03bd65857.jpg";